// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__16tri","title":"Info_title__1YiEI","links":"Info_links__1pQ8r","link":"Info_link__3uyG4","logo":"Info_logo__1BdcR"};